import React, { useState, useEffect } from "react";
import history from "../../history";
import api from '../../assets/constants/Rafservice.Instance';
import { FLAG, ISSUER_ID, HCC, WIDGET_TYPES, REPORTED_INSIGHTS, MEMBER_ID, CARRIER_ID, PLAN_ID, GENDER, MAO_RISK_CONDITION_CHART,MAO_Chart_Review_Member, MAO_MEMBER_SELECT_TAB } from "../../assets/constants/string.constants";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PersonIcon from '@material-ui/icons/Person';
import AccountBalanceTwoToneIcon from '@material-ui/icons/AccountBalanceTwoTone';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import BarChartIcon from '@material-ui/icons/BarChart';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CardComponent from "../../components/Cards/card";    
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import SlickSlider from '../../components/SlickSlider/SlickSlider';
import ServerSideGridTable from '../../components/TableGrids/ServerSideGridTable.table';
import { connect } from 'react-redux';
import { SERVICE_CATEGORY } from "../../assets/constants/string.constants";
import { getAcaYear, getAcaYearList } from "../../assets/constants/yearList";

const ServiceCategoryMember = (props) => {

    const [year, setYear] = useState(getAcaYear());
    const [hcc, setHcc] = useState( localStorage.getItem("hcc"));
    const [WidgetDetails, setWidgetDetails] = useState({});
    const[serviceCategory,setServiceCatogery] = useState(localStorage.getItem(SERVICE_CATEGORY));
    const[memberId,setMemberId] = useState(localStorage.getItem(MEMBER_ID));

    
    const WidgetDetailsType = [
        WIDGET_TYPES.LOCKICON,
        WIDGET_TYPES.MEMBERS,
        WIDGET_TYPES.PERCENT,
        WIDGET_TYPES.SCORE,
        WIDGET_TYPES.MEMBERS,
        WIDGET_TYPES.TRENDING,
        WIDGET_TYPES.PERCENT,
    ]

    const type = WidgetDetailsType;
    const widgetStyles = {
        position: 'absolute',
        left: 0,
        //right: 20,
        top: 0,
        width: '100%',
        height: '100%',
        opacity: 0.15,
        color: "white"
    };


    const claimColumns = [
        {
            label: "ClaimID",
            name: "claimID",
            
        },
        {
            label: "Utilization",
            name: "utilization",
        },
        {
            label: "%   Utilization",
            name: "percentageOfutilization",
        },
    ];

    const providerColumns = [
        {
            label: "Provider ID",
            name: "providerID",
             
        },
        {
            label: "Utilization For Specific Service",
            name: "utilization",
        },
        
        {
            label: "% Utilization For Service",
            name: "percentageOfutilization",
        },
    ];

    const getIcon = (type) => {
        var data = ''
        switch (type) {
            case WIDGET_TYPES.ISSUER:
                data = <AccountBalanceTwoToneIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.MEMBERS:
                data = <PeopleAltIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.PERCENT:
                data = <ShowChartIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.SCORE:
                data = <BarChartIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.PERSON:
                data = <PersonIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.CHILD:
                data = <PersonIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.ADULT:
                data = <PersonIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.INFANT:
                data = <PersonIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.REVENUE:
                data = <AttachMoneyIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.COUNT:
                data = <ShoppingCartIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.LOCKICON:
                data = <LockOpenIcon style={widgetStyles} />
                break;
            case WIDGET_TYPES.TRENDING:
                data = <TrendingUpIcon style={widgetStyles} />
                break;
        }

        return data;
    }
 
    useEffect(() => { 
             loadWidgetDetails();
      }, []);
    const loadWidgetDetails = () => {
        api.get('/ServiceCategoryMember/year/'+props.yearSelect+'/memberId/+'+memberId+'/sc/'+serviceCategory)
        .then(res => {
            setWidgetDetails({
                'Member ID': Number(res[0].memberID).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                'Service Category': '$'+ Number(res[0].servicecategory).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                'Utilisation': '$'+ Number(res[0].utilization).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
         });
        })
        .catch(err => {
            // console.log(err);
        });
    };


    return(<div> 
        <div className="col-lg-12 pr-0 pl-0">
                    <div className="state-level">          
                        {(Object.entries(WidgetDetails).length > 0) ?                     
                            <SlickSlider WidgetDetails={WidgetDetails} getIcon={getIcon} type={type} />
                        :
                            <></>
                        }                       
                    </div>
                </div>
<CardComponent
        heading={`PROVIDER LIST`}
        body={   
                <ServerSideGridTable
                    url={`/suUtilByServiceProvider/${props.yearSelect}/id/${memberId}/sc/${serviceCategory}`}
                    columns={providerColumns}
                 //   tableClick={hccTableClick}
                    defaultSortCol={0}
                    defaultSortDir={'desc'}
                ></ServerSideGridTable>
        }></CardComponent>
        <CardComponent
        heading={`CLAIM LIST`}
        body={   
                <ServerSideGridTable
                     url={`/suUtilByServiceClaim/${props.yearSelect}/id/${memberId}/sc/${serviceCategory}`}
                    columns={claimColumns}
                 //   tableClick={hccTableClick}
                    defaultSortCol={0}
                    defaultSortDir={'desc'}
                ></ServerSideGridTable>
        }></CardComponent>

</div>)

}; 
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        moduleSelect: state.moduleFilter.moduleSelect,
        viewBySelect: state.moduleFilter.viewBySelect,
        modelSelect: state.moduleFilter.modelSelect,
        metalTierSelect: state.moduleFilter.metalTierSelect,
        planSelect: state.moduleFilter.planSelect,
        yearSelect: state.moduleFilter.yearSelect,
        meInitialSelect: state.moduleFilter.meInitialSelect,
    };
  }
export default connect(mapStateToProps) (ServiceCategoryMember);

